import { create } from "zustand";

const initialState = {
  orderSummaryOpen: window?.post_template?.checkout_v4_summary.checkout_v4_summary_state || false,
  showPopup: false,
  isLoading: false,
  paymentMethod: "card",
  paypalButtonState: "initial",
  direct: window?.affiliate?.includes("-direct"),
  isMobile: window.innerWidth < 1071,
  mobileGallery: window.innerWidth <= 767,
  complianceDesktop: window?.complianceDesktop,
  complianceMobile: window?.complianceMobile,
  cleanMobile: window.cleanMobile,
  cleanDesktop: window.cleanDesktop,
  withProductPicker: window?.post_template?.checkout_v4_products.checkout_v4_products_show,
  totalSavingsStyle: window?.post_template?.checkout_v4_summary.checkout_v4_summary_savingsStyl,
  showBulletPoints: window?.post_template?.checkout_v4_summary.checkout_v4_summary_bullet_points ?? false,
  upsellPopup: {
    popupClicked: false,
    displayPopup: false,
    popupEnabled: window.post_template?.checkout_v4_products?.checkout_v4_upsell_popup_toggle,
  },
};

export const useTemplateStore = create((set, get) => ({
  ...initialState,
  toggleOrderSummary: (payload) => set((state) => ({ ...state, orderSummaryOpen: payload })),
  setLoadingState: (payload) => set((state) => ({ ...state, isLoading: payload })),
  showPopupState: (payload) => set((state) => ({ ...state, showPopup: payload })),
  setPopupClicked: (payload) => set((state) => ({ ...state, popupClicked: payload })),
  setDisplayPopup: (payload) => set((state) => ({ ...state, displayPopup: payload })),
  setPaypalButtonState: (payload) => set((state) => ({ ...state, paypalButtonState: payload })),
  setIsMobile: (payload) => set((state) => ({ ...state, isMobile: payload })),
  setIsMobileGallery: (payload) => set((state) => ({ ...state, mobileGallery: payload })),
  setDirect: (payload) => set((state) => ({ ...state, direct: payload })),
  enableUpsellPopup: () => {
    set((state) => ({
      ...state,
      upsellPopup: {
        ...state.upsellPopup,
        displayPopup: true,
      },
    }));
  },
  disableUpellPopup: () =>
    set((state) => ({
      ...state,
      upsellPopup: {
        ...state.upsellPopup,
        popupClicked: true,
        displayPopup: false,
      },
    })),
  handlePaymentMethodChange: (payload) => set((state) => ({ ...state, paymentMethod: payload })),
}));
